import { render, staticRenderFns } from "./participateinGroup.vue?vue&type=template&id=f16ab812&scoped=true"
import script from "./participateinGroup.vue?vue&type=script&lang=js"
export * from "./participateinGroup.vue?vue&type=script&lang=js"
import style0 from "./participateinGroup.vue?vue&type=style&index=0&id=f16ab812&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16ab812",
  null
  
)

export default component.exports